import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'x-navigate-external',
  template: `
    <div class="container py-4">
      <h2 i18n="Redirecting user to external page@@RedirectToExternal.Feedback">
        You are being redirected to:
      </h2>
      <p>{{ url }}</p>
    </div>
  `,
  preserveWhitespaces: false,
})
export class NavigateExternalComponent implements OnDestroy {
  private timeout = 2500; //ms
  private _destroy$ = new Subject<void>();

  url: string | null;
  constructor(private route: ActivatedRoute) {
    this.route.queryParamMap.pipe(takeUntil(this._destroy$)).subscribe((params) => {
      this.url = params.get('url');
      setTimeout(() => {
        if (this.url) window.location.href = this.url;
      }, this.timeout);
    });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
